<div fxLayout="column" fxFlex="100">
  <mat-card class="mb-3">
    <mat-card-header>
      <mat-card-title>Profiler</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-form-field color="primary" appearance="outline">
        <mat-label>Søg efter profil</mat-label>
        <input
          [formControl]="query"
          matInput
          (keyup.enter)="doSearch()"
          placeholder="Fx. ansoeger@grantone.dk"
          autocomplete="off"
          >
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </mat-card-content>
    <mat-card-footer>
      @if (loading) {
        <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
      }
    </mat-card-footer>
  </mat-card>

  <div class="customer-profiles-list" [@listAnimation]="profiles?.length">
    <mat-card>
      <mat-card-content  class="customer-profiles-header">
        <div fxLayout="row" fxLayoutAlign="start center">
          <div fxFlex="20">Navn</div>
          <div fxFlex="25">Login</div>
          <div fxFlex="10">Type</div>
          <div fxFlex="15">Seneste login</div>
          <div fxFlex="30"></div>
        </div>
      </mat-card-content>
    </mat-card>

    @for (profile of profiles; track profile) {
      <mat-card class="profile-card">
        <mat-card-content>
          <div fxLayout="row" fxLayoutAlign="start center">
            <div fxFlex="20">{{profile.name}}</div>
            <div fxFlex="25">
              @if (profile.provider === 'email') {
                <span>{{profile.uid}}</span>
              }
            </div>
            <div fxFlex="10">
              @switch (profile.provider) {
                @case ('email') {
                  <span>E-mail</span>
                }
                @case ('nemid') {
                  <span>
                  {{ isEmployeeNemId(profile) ? 'Medarbejder ' : '' }}
                    NemID
                </span>
                }
                @case ('mitid') {
                  <span>MitID</span>
                }
                @default {
                  <span>{{profile.provider}}</span>
                }
              }
            </div>
            <div fxFlex="15">
              @if (profile.last_sign_in_at) {
                <span>{{profile.last_sign_in_at | date: 'dd.MM.yyyy HH:mm'}}</span>
              }
              @if (!profile.last_sign_in_at) {
                <span>Aldrig</span>
              }
            </div>
            <div fxFlex="30" fxLayout="row" fxLayoutAlign="end center">
              @if (profile.provider === 'email' && profile.locked_at) {
                <button mat-icon-button
                        matTooltip="Lås op"
                        aria-label="Lås op"
                        (click)="doUnlock(profile)">
                  <mat-icon>lock_open</mat-icon>
                </button>
              }
              @if (profile.provider === 'email' && isResetTokenExpired(profile) && !profile.locked_at) {
                <button mat-icon-button
                        matTooltip="Nulstil adgangskode"
                        aria-label="Nulstil adgangskode"
                        (click)="doResetPassword(profile)">
                  <mat-icon>lock_reset</mat-icon>
                </button>
              }
              @if (profile.provider === 'email' && profile.reset_password_expires_at && !isResetTokenExpired(profile) && !profile.locked_at) {
                <button  mat-icon-button
                         matTooltip="Skift adgangskode"
                         aria-label="Skift adgangskode"
                         (click)="goToChangePassword(profile)">
                  <mat-icon>open_in_new</mat-icon>
                </button>
              }
              <button mat-icon-button
                      matTooltip="Login som profil"
                      aria-label="Login som profil"
                      (click)="goToProfile(profile)">
                <mat-icon>switch_account</mat-icon>
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    }
  </div>

</div>
